import { useMemo } from 'react'
import Image, { StaticImageData } from 'next/image'

import authImage1 from '/src/lib/assets/images/authentication-image-1.jpg'
import authImage2 from '/src/lib/assets/images/authentication-image-2.jpg'
import authImage3 from '/src/lib/assets/images/authentication-image-3.jpg'

type ImageProps = {
  data: StaticImageData
  alt: string
}

const IMAGE_LIST: ImageProps[] = [
  {
    data: authImage1,
    alt: 'Mulher sorrindo enquanto segura um celular e um cartão Swile em suas mãos.'
  },
  {
    data: authImage2,
    alt: 'Mulher sorrindo em um fundo desfocado enquanto exibe um cartão Swile à sua frente.'
  },
  {
    data: authImage3,
    alt: 'Mulher sorrindo enquanto segura e olha para um cartão Swile'
  }
]

export const HeroImage = () => {
  const image = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * IMAGE_LIST.length)

    return IMAGE_LIST[randomIndex]
  }, [])

  return (
    <Image
      src={image.data}
      alt={image.alt}
      priority
      className="h-full w-full object-cover brightness-50"
    />
  )
}
